// Accepted payment method badges — lightweight inline SVGs, theme-matched.
const BADGE = "flex h-[22px] items-center justify-center rounded-[4px] border border-white/15 bg-white/[0.06] px-1.5";

export function VisaBadge() {
  return (
    <span className={BADGE} title="Visa">
      <svg width="30" height="10" viewBox="0 0 30 10" aria-label="Visa">
        <text x="15" y="8.5" textAnchor="middle" fontSize="9" fontWeight="800" fontStyle="italic" fill="#8FA3E8" fontFamily="Arial, sans-serif" letterSpacing="0.5">VISA</text>
      </svg>
    </span>
  );
}

export function MastercardBadge() {
  return (
    <span className={BADGE} title="Mastercard">
      <svg width="26" height="16" viewBox="0 0 26 16" aria-label="Mastercard">
        <circle cx="10" cy="8" r="6.5" fill="#EB001B" />
        <circle cx="16" cy="8" r="6.5" fill="#F79E1B" fillOpacity="0.85" />
      </svg>
    </span>
  );
}

export function AmexBadge() {
  return (
    <span className={BADGE} title="American Express">
      <svg width="32" height="10" viewBox="0 0 32 10" aria-label="American Express">
        <text x="16" y="8" textAnchor="middle" fontSize="7.5" fontWeight="800" fill="#7FB3E0" fontFamily="Arial, sans-serif" letterSpacing="0.5">AMEX</text>
      </svg>
    </span>
  );
}

export function PayPalBadge() {
  return (
    <span className={BADGE} title="PayPal">
      <svg width="36" height="10" viewBox="0 0 36 10" aria-label="PayPal">
        <text x="18" y="8" textAnchor="middle" fontSize="8" fontWeight="800" fontStyle="italic" fontFamily="Arial, sans-serif">
          <tspan fill="#9FB8E8">Pay</tspan><tspan fill="#6FC6E8">Pal</tspan>
        </text>
      </svg>
    </span>
  );
}

export function PaymentBadges({ className = "" }) {
  return (
    <div className={`flex items-center gap-1.5 ${className}`} data-testid="payment-badges">
      <VisaBadge />
      <MastercardBadge />
      <AmexBadge />
      <PayPalBadge />
    </div>
  );
}
